import {Component, OnInit, Input} from '@angular/core';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { BsLocaleService, defineLocale } from 'ngx-bootstrap';
import { frLocale } from 'ngx-bootstrap/locale';


@Component({
  selector: 'app-filter-subscriptions',
  templateUrl: './filter-subscriptions.component.html',
  styleUrls: ['./filter-subscriptions.component.css']
})
export class FilterSubscriptionsComponent implements OnInit {

  @Input() assocsForFilter: any[] = [];

  public form: FormGroup;
  public statuses = [
    {id: 'NA', value: 'n/a'},
    {id: 'ACTIVE', value: 'Active'},
    {id: 'CLOSED', value: 'Terminée'},
    {id: 'CANCELED', value: 'Suspendue'}
  ];

  constructor(public activeModal: NgbActiveModal, private formbuilder: FormBuilder, private localeService: BsLocaleService) {
    // tslint:disable-next-line:max-line-length
    const patternEmail = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.form = this.formbuilder.group({
      'email': ['', Validators.pattern(patternEmail)],
      'status': ['ALL', Validators.required],
      'assoc': ['ALL', Validators.required]
    });
    defineLocale(frLocale.abbr, frLocale);
    this.localeService.use('fr');
  }

  ngOnInit() {
  }

  onSubmit() {
    this.validateAllFormFields(this.form);

    if (this.form.valid) {
      this.activeModal.close(this.form.value);
    }
  }

  /**
* Validate all FormControl
* @param formGroup FormGroup instance
*/
  private validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
